import React from "react";

// Shared typographic wrapper for legal pages (Privacy, Terms). Keeps the
// prose styling consistent without depending on a Tailwind typography plugin.

export function LegalBody({ children, updated }) {
  return (
    <div data-testid="legal-body" className="max-w-3xl mx-auto py-16 md:py-20">
      {updated && (
        <p className="text-xs uppercase tracking-[0.18em] text-[#946f36] mb-10">
          Last updated: {updated}
        </p>
      )}
      <div className="legal-prose space-y-10 text-[#4A3728] leading-relaxed">
        {children}
      </div>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section>
      <h2 className="font-serif-display text-2xl md:text-3xl text-[#281a12] mb-4">
        {title}
      </h2>
      <div className="space-y-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_a]:text-[#6e5022] [&_a]:underline hover:[&_a]:text-[#946f36]">
        {children}
      </div>
    </section>
  );
}
